import type { CharacterActivity, CharacterGesture, CharacterLoop, PoseFrame } from './character-animator.js';

type Hands = { left: boolean; right: boolean };
const neither: Hands = { left: false, right: false };
const right: Hands = { left: false, right: true };
const both: Hands = { left: true, right: true };

const idleHands: Record<CharacterGesture, Hands> = {
  'fidget-stretch': both, 'fidget-ground': both, 'fidget-look': neither, 'fidget-scratch': right,
  wave: right, cheer: both, point: right, bow: neither,
};
const activityHands: Record<CharacterActivity, Hands> = {
  talk: both, drink: right, 'study-map': both, stretch: both, 'warm-hands': both, pray: both, mend: both, dig: both,
};
const loopHands: Record<CharacterLoop, Hands> = {
  'runway-walk': neither, 'dance-sway': both, 'dance-step': right, 'dance-flourish': both,
};

/** Stow only the equipment whose hand is needed for a contact or an empty-hand gesture. */
export function equipmentHands(frame: Pick<PoseFrame, 'idle' | 'activity' | 'loop' | 'pair' | 'authored' | 'channel'>): Hands {
  // Authored clips have no hand-use metadata; reserve both until that contract exists.
  if (frame.authored || frame.channel) return both;
  if (frame.pair) return frame.pair.kind === 'handshake' ? right : both;
  if (frame.activity) return activityHands[frame.activity.kind];
  if (frame.loop) return loopHands[frame.loop.kind];
  if (frame.idle) return idleHands[frame.idle.kind];
  return neither;
}
